import type { CSSProperties, FC, ReactNode } from 'react';
import { PDF_BORDER } from '../constants';

type Props = {
  children: ReactNode;
  style?: CSSProperties;
};

export const Tfoot: FC<Props> = ({ children, style }) => (
  <tfoot
    style={{
      breakInside: 'avoid',
      border: PDF_BORDER.NORMAL,
      boxSizing: 'border-box',
      display: 'table-row-group', // NOTE: To avoid bottom-fixation when printing
      ...style,
    }}
  >
    {children}
  </tfoot>
);
